import adContract from './resource';
import errorTransformer from '../shared/transformers/errorTransformer';

function getContract() {
  return adContract
    .get()
    .then(({ body: contract }) => contract)
    .catch(errorTransformer);
}

function acceptContract(id) {
  return adContract
    .acceptContract({ itemId: id })
    .then(({ body: { message, contract } }) => ({
      message,
      contract,
    }))
    .catch(errorTransformer);
}

function getStatus() {
  return adContract
    .getStatus()
    .then(({ body }) => body)
    .catch(errorTransformer);
}

export default { getContract, acceptContract, getStatus };
